import { createApp } from "vue";
import { createPinia } from "pinia";
import { VueQueryPlugin } from "@tanstack/vue-query";
import VueFeather from "vue-feather";
import "@/shared/icons";

import VueDatePicker from "@vuepic/vue-datepicker";


import "@vuepic/vue-datepicker/dist/main.css";

import App from "@/App.vue";
import router from "@/router";

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  DoughnutController,
  ArcElement,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
} from "chart.js";

import moment from "@/plugins/moment/config";
import "@/plugins/simple-body-validator/config";
import "@/plugins/mapbox/config";

import "mapbox-gl/dist/mapbox-gl.css";
import "@mapbox/mapbox-gl-directions/dist/mapbox-gl-directions.css";
import "@/style.css";

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  BarElement,
  DoughnutController,
  ArcElement,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement
);


const app = createApp(App);
const pinia = createPinia();

app.config.globalProperties.$moment = moment;

app.component(VueFeather.name, VueFeather);
app.component("VueDatePicker", VueDatePicker);

app.use(pinia);
app.use(router);

VueQueryPlugin.install(app, {
  queryClientConfig: {
    defaultOptions: {
      queries: {
        cacheTime: 1000 * 60, // 1 minuto
        staleTime: 1000 * 60,
        // retry: 3,
      },
    },
  },
});
app.mount("#app");
